import React from "react";
import ScrollAnimation from "react-animate-on-scroll";
import SectionTitle from "../sectionTitle/SectionTitle";
import FooterOne from "../../common/footer/FooterOne";
import SEO from "../../common/SEO";
import BreadcrumbOne from "../../common/breadcrumb/BreadcrumbOne";
import Layout from "../../common/Layout";

const ManagerModule = (props) => {
    const isHomePage = window.location.pathname === "/" || window.location.pathname === "/termekeink/szoftver";
    return (
        <Layout>
            {!props.fromHome && <SEO title={"Manager / Tulajdonos statisztikák modul"}
                                     description={"Az étterem vezetése számára bármikor elérhető elemzéseket, kimutatásokat kínál a döntési folyamatot támogatva.Nyomon követhető az össszes aktuális foglalási, forgalmi információ, akár egy mobiltelefonról. Látható ki dolgozik, átvételre került-e a reggel beérkezett szállítmány, milyen státuszban vannak a jelenlegi rendelések a helyszínen vagy a házhozszállítás folyamata épp hol tart, stb ... Minden folyamat és adat részletesen és adott pillanatban, dinamikusan ellenőrizhető.\n"}/>}
            <BreadcrumbOne
                style={{backgroundImage: `url('https://images.unsplash.com/photo-1664575602276-acd073f104c1?q=80&w=3270&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')`}}
                title={"<font style='color: white'>Manager / Tulajdonos statisztikák modul</font>"}
                rootUrl="/"
                parentUrl={"<font style='color: white'>Termékeink</font>"}
                currentUrl={"<font style='color: white'>Manager / Tulajdonos statisztikák modul</font>"}
            />
            <div className="edu-about-area about-style-3 edu-section-gap bg-image">
                <div className="container eduvibe-animated-shape">
                    <div className="row g-5">

                        <div className="col-lg-6" id={"delivery-module"}>
                            <div className="inner">
                                <SectionTitle
                                    classes="text-start"
                                    slogan="Vezetői irányítópult - Minden adat a kezedben!"
                                    title="Manager / Tulajdonos statisztikák modul"
                                />
                                <ScrollAnimation
                                    animateIn="fadeInUp"
                                    animateOut="fadeInOut"
                                    animateOnce={true}
                                >
                                    <strong>
                                        A Happy Gastro Vezetői irányítópulttal a kezedben tarthatod az irányítást!
                                    </strong>
                                    <p className="description mt--40">
                                        Az étterem vezetése számára bármikor elérhető elemzéseket, kimutatásokat kínál a
                                        döntési folyamatot támogatva.Nyomon követhető az össszes aktuális foglalási,
                                        forgalmi információ, akár egy mobiltelefonról. Látható ki dolgozik, átvételre
                                        került-e a reggel beérkezett szállítmány, milyen státuszban vannak a jelenlegi
                                        rendelések a helyszínen vagy a házhozszállítás folyamata épp hol tart, stb ...
                                        Minden folyamat és adat részletesen és adott pillanatban, dinamikusan
                                        ellenőrizhető.
                                    </p>
                                </ScrollAnimation>
                                <ScrollAnimation
                                    animateIn="fadeIn"
                                    animateOut="fadeInOut"
                                    className="testimonial-left-image"
                                    animateOnce={true}
                                    style={{margin: '5rem 0'}}
                                >
                                    <div className="thumbnail">
                                        <div className="circle-image-wrapper" style={{width: "37rem"}}>
                                            <img
                                                style={{width: '35rem', height: "35rem", objectFit: 'cover'}}
                                                className="radius-round"
                                                src="https://images.unsplash.com/photo-1591696205602-2f950c417cb9?q=80&w=3270&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                                                alt="Futár modul"/>
                                            <div className="circle-image">
                                                <span></span>
                                                <span></span>
                                            </div>
                                        </div>
                                    </div>
                                </ScrollAnimation>
                            </div>
                        </div>

                        <div className="col-lg-6" id={"delivery-module"}>
                            <div className="inner">
                                <ScrollAnimation
                                    animateIn="fadeInUp"
                                    animateOut="fadeInOut"
                                    className="col-lg-12 p-0"
                                    animateOnce={true}
                                >
                                    <div className="edu-feature-list">
                                        <div className="content">
                                            <h6 className="title d-flex align-items-center">
                                                <i className="ri-arrow-drop-right-line"></i>
                                                Valós idejű elemzések
                                            </h6>
                                            <p className="description">
                                                Döntéshozatal a legfrissebb információk alapján.
                                            </p>
                                        </div>
                                    </div>
                                </ScrollAnimation>

                                <ScrollAnimation
                                    animateIn="fadeInUp"
                                    animateOut="fadeInOut"
                                    className="col-lg-12 p-0"
                                    animateOnce={true}
                                >
                                    <div className="edu-feature-list">
                                        <div className="content">
                                            <h6 className="title d-flex align-items-center">
                                                <i className="ri-arrow-drop-right-line"></i>
                                                Teljeskörű betekintés
                                            </h6>
                                            <p className="description">
                                                Forgalmi adatok, foglalások, rendelések, szállítmányok egy helyen.
                                            </p>
                                        </div>
                                    </div>
                                </ScrollAnimation>

                                <ScrollAnimation
                                    animateIn="fadeInUp"
                                    animateOut="fadeInOut"
                                    className="col-lg-12 p-0"
                                    animateOnce={true}
                                >
                                    <div className="edu-feature-list">
                                        <div className="content">
                                            <h6 className="title d-flex align-items-center">
                                                <i className="ri-arrow-drop-right-line"></i>
                                                Mobil elérés
                                            </h6>
                                            <p className="description">
                                                Bármikor, bárhonnan elérhető információk.
                                            </p>
                                        </div>
                                    </div>
                                </ScrollAnimation>

                                <ScrollAnimation
                                    animateIn="fadeInUp"
                                    animateOut="fadeInOut"
                                    className="col-lg-12 p-0"
                                    animateOnce={true}
                                >
                                    <div className="edu-feature-list">
                                        <div className="content">
                                            <h6 className="title d-flex align-items-center">
                                                <i className="ri-arrow-drop-right-line"></i>
                                                Részletes kontroll
                                            </h6>
                                            <p className="description">
                                                Minden folyamat nyomon követése dinamikusan.
                                            </p>
                                        </div>
                                    </div>
                                </ScrollAnimation>
                                <ScrollAnimation
                                    animateIn="fadeInUp"
                                    animateOut="fadeInOut"
                                    className="col-lg-12 p-0"
                                    animateOnce={true}
                                >
                                    <a href="https://play.google.com/store/apps/details?id=org.happysolutions.admin&referrer=utm_source=manager-modul-hg" target="_blank" rel="noopener noreferrer">
                                        <img
                                            src="/GetItOnGooglePlay_Badge.png"
                                            alt="Get it on Google Play"
                                            style={{ maxWidth: '200px', minHeight: '0.3in', margin: 15 }}
                                        />
                                    </a>
                                </ScrollAnimation>
                            </div>
                        </div>
                    </div>

                    <div className="shape-dot-wrapper shape-wrapper d-xl-block d-none">
                        <div className="shape-image shape-image-1">
                            <img src="/images/shapes/shape-21.png" alt="Shape Thumb"/>
                        </div>
                        <div className="shape-image shape-image-2">
                            <img src="/images/shapes/shape-13-04.png" alt="Shape Thumb"/>
                        </div>
                        <div className="shape-image shape-image-3">
                            <img src="/images/shapes/shape-03-05.png" alt="Shape Thumb"/>
                        </div>
                        <div className="shape-image shape-image-4">
                            <img src="/images/shapes/shape-15-02.png" alt="Shape Thumb"/>
                        </div>
                    </div>
                </div>
            </div>
            {!isHomePage && <FooterOne/>}
        </Layout>
    );
};

export default ManagerModule;
